import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';
import BitConfigType from '~/mst/common/bit_config_type';

const DataRamSensor = t.compose(
  t.model({
    auto_zero: t.frozen(),
    auto_zero_enabled: t.maybe(BitConfigType),
    auto_zero_time: t.frozen(),
    flow_calibration: t.frozen()
  }),
  Sensor
);

export interface IDataRamSensor extends Instance<typeof DataRamSensor> {}

export default DataRamSensor;
